import styled from '../../../../../theme'
import { IWithSize } from '../../../Calendar/Calendar'

const Title = styled.div<IWithSize>`
  font-size: ${({ size }) => (size ? 16 * size : 16)}px;
  font-weight: 500;
  margin-left: ${({ size }) => (size ? 15 * size : 15)}px;
`

export default Title
